import { render, staticRenderFns } from "./dealPaidInfo.vue?vue&type=template&id=681a8f42&scoped=true&"
import script from "./dealPaidInfo.vue?vue&type=script&lang=js&"
export * from "./dealPaidInfo.vue?vue&type=script&lang=js&"
import style0 from "./dealPaidInfo.vue?vue&type=style&index=0&id=681a8f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a8f42",
  null
  
)

export default component.exports